import { useToast } from '@chakra-ui/react'
import { useModalState } from '~/atoms/ModalState'
import { MangoAlert } from '~/components/shared/MangoAlert'
import { NotificationDisposition } from '~/services/EventEmitter/types/NotificationEmitterTypes'

const TOAST_LOGGED_IN_ID = 'CallQueue_LoggedIn'
const TOAST_LOGGED_OUT_ID = 'CallQueue_LoggedOut'
const TOAST_STATUS_UPDATED_ID = 'CallQueue_StatusUpdated'
export const useQueueAlerts = () => {
  const toast = useToast({
    duration: 4000,
    isClosable: true,
    position: 'bottom-right',
  })
  const {
    confirmModal: [, setConfirmModalState],
  } = useModalState()

  const showQueueUpdateErrorModal = () => {
    setConfirmModalState({
      title: 'Unable to update status',
      message:
        'Please make sure this User/Extension is added to a Call Queue in the Admin Portal or contact Support.',
      confirmText: 'OK',
      closeAfterConfirm: true,
      isDestructive: false,
      onConfirm: () => {},
    })
  }

  const showLoggedInToast = () => {
    toast.close(TOAST_LOGGED_IN_ID)
    toast({
      id: TOAST_LOGGED_IN_ID,
      render: () => (
        <MangoAlert
          title="Logged in to queue"
          status={NotificationDisposition.Success}
          closeOnClick
          onClose={() => {
            toast.close(TOAST_LOGGED_IN_ID)
          }}
        />
      ),
    })
  }

  const showLoggedOutToast = () => {
    toast.close(TOAST_LOGGED_OUT_ID)
    toast({
      id: TOAST_LOGGED_OUT_ID,
      render: () => (
        <MangoAlert
          title="Logged out of queue"
          status={NotificationDisposition.Error}
          closeOnClick
          onClose={() => {
            toast.close(TOAST_LOGGED_OUT_ID)
          }}
        />
      ),
    })
  }

  const showStatusUpdatedToast = () => {
    toast.closeAll()
    toast({
      id: TOAST_STATUS_UPDATED_ID,
      render: () => (
        <MangoAlert
          title="Agent status updated"
          status={NotificationDisposition.Success}
          closeOnClick
          onClose={() => {
            toast.close(TOAST_STATUS_UPDATED_ID)
          }}
        />
      ),
    })
  }

  return {
    showLoggedInToast,
    showLoggedOutToast,
    showQueueUpdateErrorModal,
    showStatusUpdatedToast,
  }
}
